module.exports = __webpack_public_path__ + "ed4b1c3196637198d2fab2c67d1a541a.fbx";